import { useState } from "react";
import { Form } from "react-bootstrap";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormControlWrapper } from "./formControlWrapper";

export const FieldDefaultText = ({
	isDisabled,
	error,
	fieldData,
	placeholder = "",
	formType = "text",
	title = "",
	tooltip,
	maxLength,
	autoFocus,
	setValue = () => {},
}) => {
	const [isHidden, setIsHidden] = useState(true);

	const isText = formType === "password" && !isHidden;

	return (
		<FormControlWrapper
			title={title}
			tooltip={tooltip}
			data-testid="test-fieldText"
			error={error}
		>
			<Form.Control
				data-testid="test-fieldTextControl"
				disabled={isDisabled}
				type={isText ? "text" : formType}
				defaultValue={fieldData || ""}
				placeholder={placeholder}
				maxLength={maxLength}
				isInvalid={!!error}
				onKeyUp={(e) => setValue(e.target.value)}
				autoFocus={autoFocus}
			/>
			<FontAwesomeIcon
				onClick={() => {
					setIsHidden((isHiddenSaved) => !isHiddenSaved);
				}}
				className="dataFormControlIcon"
				hidden={formType !== "password"}
				variant="secondary"
				icon={faEye}
			/>
		</FormControlWrapper>
	);
};
